import { fokaAxios } from 'app/fokaAxios'

export default {
  getRestrictionIp: id => fokaAxios.get(`/api/v2/restriction/ips/${id}`),
  getRestrictionIps: ({ page, size }) =>
    fokaAxios.get('/api/v2/restriction/ips', {
      params: {
        page,
        limit: size,
        sort: 'createdDate desc',
      },
    }),
  addRestrictionIp: ({ ip, description }) =>
    fokaAxios.post('/api/v2/restriction/ips', { ip, description }),
  deleteRestrictionIps: ({ ids }) =>
    fokaAxios.delete('/api/v2/restriction/ips', { data: { ids } }),
  updateRestrictionIpDescription: ({ id, description }) =>
    fokaAxios.patch(`/api/v2/restriction/ips/${id}`, { description }),
  getCsvString: () => fokaAxios.get('/api/v2/restriction/ips/download'),
}
